<template>
  <app-multiselect
    ref="appMultiSelect"
    v-bind="{ ...$attrs, ...$props }"
    v-on="$listeners"
  >
    <template v-slot:singleLabel="props">
      <img
        v-if="showAvatar"
        :src="getAvatar(props.option)"
        :alt="props.option.$groupLabel"
        class="img-circle hidden-xs"
        style="height: 25px;"
      >

      <span class="icon" v-if="showAvailabilityIcon">
        <img :src="availabilityIcon(props.option)">
      </span>

      {{  props.option.name }}
    </template>

    <template v-slot:noSearchResults>
      <span class="no-result" style="padding-left: 70px;">Geen chauffeurs gevonden</span>
    </template>

    <template v-slot:optionSlot="props">
      <span v-if="props.option.$isLabel">
        <span class="icon">
          <img :src="availabilityIcon(props.option)">
        </span>

        <span class="name">
            {{ props.option.$groupLabel }}
        </span>
      </span>

      <span v-else>
        <span class="name" :class="{'has-availabilities': props.option.availability}">
            <span
              class="icon"
              v-if="showAvailabilityIcon"
            >
              <img :src="availabilityIcon(props.option)">
            </span>

            {{ props.option.name }}<br>

            <span
              class="availabilities"
              style="text-align: right"
              v-if="showAvailabilities && props.option.availabilities"
            >
              {{ availabilityList(props.option) }}<br>
              {{ locationsList(props.option) }}
              <i v-if="isChanged(props.option)" class="fa fa-exclamation-triangle" data-toggle="tooltip" title="Beschikbaarheid is aangepast na versturen notificatie"></i>
            </span>
        </span>

      </span>
    </template>
  </app-multiselect>

</template>

<script>
  import AppMultiselect from "../AppMultiselect";

  export default {
    name: 'DriverAvailabilityMultiSelect',

    components: { AppMultiselect },

    props: {
      availabilities: {
        type: Array,
        default: null,
      },

      showAvailabilities: {
        type: Boolean,
        default: true,
      },

      showAvailabilityIcon: {
        type: Boolean,
        default: false,
      },

      showAvatar: {
        type: Boolean,
        default: false,
      },
    },

    methods: {
      activate() {
        this.$refs.appMultiSelect.activate();
      },

      deactivate() {
        this.$refs.appMultiSelect.deactivate();
      },

      getAvatar(row) {
        return row.avatar_url;
      },

      availabilityIcon(row) {
        if (row.availability_icon) {
          return row.availability_icon;
        }

        if (this.availabilities) {
          let availability = this.availabilities.find((availability) => availability.title === row.title);

          return availability.icon;
        }
      },
      availabilityList(row) {
        if (row.availabilities) {
          if (row.availabilities[0] && row.availabilities[0].availability) {
            if (row.availabilities[0].availability.name === 'unavailable') {
              return 'gehele dag niet beschikbaar';
            } else if (row.availabilities[0].available_all_day) {
              return 'gehele dag beschikbaar';
            } else if (row.availabilities[0].unavailable_all_day && row.availabilities[0].availability.name !== 'available' ) {
              return 'gehele dag niet beschikbaar'
            }
          }

          return row.availabilities.map((availability) => {
            const from = moment(availability.available_from).format('HH:mm')
            const to = moment(availability.available_to).format('HH:mm')

            return `${from}-${to}`
          }).join(' & ');
        }
      },
      locationsList(row) {
        if (row.availabilities) {
          if (row.availabilities[0] && row.availabilities[0].availability) {
            if (row.availabilities[0].availability.name === 'unavailable') {
              return '';
            } else if (row.availabilities[0].unavailable_all_day && row.availabilities[0].availability.name !== 'available' ) {
              return ''
            }
          }
          return row.availabilities.map((availability) => {
            if (availability.availability.name === 'unavailable') {
              return '';
            }

            let from = '';
            if (availability.from_location) {
              from = availability.from_location.city;
              if (availability.from_location.province) {
                from = `${from} (${availability.from_location.province_short})`;
              }
            }

            let to = '';
            if (availability.to_location) {
              to = availability.to_location.city
              if (availability.to_location.province_short) {
                to = `${to} (${availability.to_location.province_short})`;
              }
            }

            return `${from} - ${to}`
          }).join(' & ');
        }
      },
      isChanged(row) {
        if (row.availabilities && row.availabilities[0]) {
          return row.availabilities[0].changed;
        }

        return false;
      }
    }
  }
</script>

<style scoped>
.multiselect__element {
  border-bottom: 1px solid #f1f1f1;
}
.multiselect__option span.name {
  font-size: 14px;
  display: inline-block;
  float:left;
  padding-left: 10px; }
.multiselect__tags .multiselect__option:before {
  position: absolute; left:0px; top:0px;
}
.multiselect__option span.name .availabilities {
  font-size: 11px;
  font-weight: 300;
  float: right;
  position: absolute;
  right: 20px;
  top: 5px;
}

</style>



// WEBPACK FOOTER //
// resources/js/components/drivers/DriverAvailabilityMultiSelect.vue